import {post} from '@/utils/request';
import{erpserver,erpplatserver,attendanceserver} from '@/utils/baseUrl';

//列表
export async function overtimeList(params) {
    return post(attendanceserver+'/attendence/overtimeList', params, true)
}
//搜索框模糊查询
export async function searchUser(params) {
    return post(attendanceserver+'/attendence/searchUser', params, true)
}
//保存
export async function saveOvertime(params) {
    return post(attendanceserver+'/attendence/saveOvertime', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//获取报表时间
export async function time(params) {
    return post(attendanceserver+'/attendence/kqtc/time', params, true)
}
//下载明细合计
export async function getExcel(params) {
    return post(attendanceserver+'/attendence/getExcel', params, true)
}

//子列表
export async function getOvertimeSqSubList(params) {
    return post(attendanceserver+'/attendence/getOvertimeSqSubList', params, true)
}
//识别码列表
export async function listVcCode(params) {
    return post(attendanceserver+'/attendence/listVcCode', params, true)
}
//补卡识别码列表
export async function listVcBkCode(params) {
    return post(attendanceserver+'/attendence/listVcBkCode', params, true)
}
//受理
export async function approveOvertimeSq(params) {
    return post(attendanceserver+'/attendence/approveOvertimeSq', params, true)
}
//受理补卡
export async function approveOvertimeBk(params) {
    return post(attendanceserver+'/attendence/approveOvertimeBk', params, true)
}